module.exports = __webpack_public_path__ + "js/pdf-worker.3d584691.worker.js"